import { useQuery } from "@tanstack/react-query";

import { authGet } from "@shared/api";
import { NOTIFICATIONS_URL } from "@shared/constants";
import { NangoTicketingInstance } from "@shared/types";

import { useOrgAssertDefined } from "../useOrgAssertDefined";

// fetches the primary ticketing instance for a deployment
// only fetches the first ticketing instance
// returns null if there is no ticketing instance (hasn't been configured)
export const fetchPrimaryNangoTicketingInstance = async (
  deploymentId: number
): Promise<NangoTicketingInstance | null> => {
  return authGet<NangoTicketingInstance[]>(
    `${NOTIFICATIONS_URL}/${deploymentId}/ticketing/v2`
  ).then((res) => (res.length > 0 ? res[0] : null));
};

export const usePrimaryNangoTicketingInstance = () => {
  const org = useOrgAssertDefined();

  return useQuery({
    queryKey: ["PrimaryNangoTicketingInstance", { org }],
    queryFn: () => fetchPrimaryNangoTicketingInstance(org.id),
  });
};
